import { Link } from "react-router";

interface BackLinkProps {
  readonly to: string;
  readonly label: string;
}

/** "← Friends": the way back, in the product's type rather than the browser's. */
export function BackLink({ to, label }: BackLinkProps) {
  return (
    <Link to={to} className="label inline-flex min-h-11 items-center text-ink no-underline">
      ← {label}
    </Link>
  );
}
